import React, { useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StarIcon from '@mui/icons-material/Star';
import { useTranslation } from 'react-i18next';

export default function ZoomableImage(props) {
    const { thumbUrl, fullResUrl, thumbClass, thumbStyle, isMarkedForReport } = props;
    const [isOpen, setIsOpen] = useState(false);
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img
                src={thumbUrl}
                alt="Thumbnail"
                className={thumbClass}
                style={{
                    cursor: 'pointer',
                    width: thumbClass || thumbStyle ? undefined : '300px',
                    position: 'relative',
                    ...thumbStyle,
                }}
                onClick={() => setIsOpen(true)}
            />
            {isMarkedForReport && (
                <Tooltip title={t('survey.includetopdf')} arrow>
                    <Box
                        data-testid="report-marker"
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            left: '10px',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            borderRadius: '15%',
                            p: '2px',
                            zIndex: 10,
                        }}>
                        <StarIcon sx={{ color: theme.palette.primary.dark }} />
                    </Box>
                </Tooltip>
            )}
            {isOpen && (
                <Box
                    onClick={() => setIsOpen(false)}
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}>
                    <Box
                        component="img"
                        src={fullResUrl}
                        alt="Zoomed"
                        sx={{
                            width: '80%',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                        }}
                    />
                </Box>
            )}
        </Box>
    );
}
